import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TermsBody } from "@/components/TermsOfUse";

export default function TermsGate() {
  const { user, refresh, logout } = useAuth();
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  if (!user || user.terms_accepted_at) return null;

  const accept = async () => {
    if (!checked) return;
    setSaving(true);
    try {
      await api.post("/auth/accept-terms");
      await refresh();
      toast.success("Terms accepted");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setSaving(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/70 p-4" data-testid="terms-gate">
      <div className="flex max-h-[90vh] w-full max-w-2xl flex-col rounded-2xl bg-white shadow-xl">
        <div className="border-b border-slate-200 px-6 py-4">
          <h2 className="text-xl font-bold text-slate-900 font-heading">Terms of Use</h2>
          <p className="mt-0.5 text-sm text-slate-500">Please review and accept to continue using RallyPointGo.</p>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4"><TermsBody /></div>
        <div className="border-t border-slate-200 px-6 py-4">
          <div className="flex items-start gap-3 text-sm text-slate-700">
            <Checkbox id="terms-accept-cb" checked={checked} onCheckedChange={(v) => setChecked(!!v)} data-testid="terms-accept-checkbox" className="mt-0.5" />
            <label htmlFor="terms-accept-cb" className="cursor-pointer">I have read and agree to the RallyPointGo Terms of Use.</label>
          </div>
          <div className="mt-4 flex items-center gap-3">
            <Button onClick={accept} disabled={!checked || saving} className="flex-1 rounded-full bg-slate-900 hover:bg-slate-800" data-testid="terms-accept-btn">
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Accept & continue
            </Button>
            <Button variant="ghost" className="rounded-full text-slate-500" onClick={logout} data-testid="terms-decline-btn">
              Sign out
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
